<!-- Classic template (unchanged) -->
<ng-container *ngIf="design === 'classic'; else modernLayout">
  <div class="body-modern-wrapper">
    <div class="body-wrapper">
      <div class="header">
        <app-header
          (changeMenuSizeClass)="onChangeMenuSizeClass($event)"
        ></app-header>
      </div>

      <div class="content-wrapper">
        <div class="main-menu short-menu">
          <app-nav [(sizeMenuClass)]="menuSizeClass"></app-nav>
        </div>

        <div [ngClass]="contentClass" class="content">
          <xng-breadcrumb class="cust-brcmbs" separator=" ">
            <ng-container *xngBreadcrumbItem="let breadcrumb">
              <ng-container>{{ breadcrumb | translate }}</ng-container>
            </ng-container>
          </xng-breadcrumb>

          <div class="body">
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        </div>
      </div>

      <div class="footer">
        {{ "home.FOOTER" | translate }} <span> v{{ version }} </span>
      </div>
    </div>
  </div>
</ng-container>

<!-- Modern template (two-column, no top header/footer) -->
<ng-template #modernLayout>
  <div class="modern-root">
    <app-background-modern></app-background-modern>
    <div [class.collapsed]="menuSizeClass === 'small'" class="modern-container">

      <app-nav-bar />

      <!-- Right column -->
      <main [ngClass]="{ 'right-col': true, wrapper: !isHomePage }">
        <div class="main-content">
          <div class="right-top">
            <xng-breadcrumb class="cust-brcmbs" separator=" ">
              <ng-container *xngBreadcrumbItem="let breadcrumb">
                <ng-container>
                  {{ breadcrumb | translate }}
                </ng-container>
              </ng-container>
            </xng-breadcrumb>

            <div *ngIf="user" class="profile-wrapper">
              <div class="profile">
                <span class="login">{{ user.login }}</span>
                <ng-container *ngIf="user.photoUrlSmallSize; else noAvaModern">
                  <img
                    [src]="user.photoUrlSmallSize"
                    class="avatar-icon avatar-icon__border"
                  />
                </ng-container>
                <ng-template #noAvaModern>
                  <app-icon
                    [class]="'no-avatar'"
                    [color]="'#ffffff'"
                    [iconName]="['Peoples', 'user']"
                    [icon]="'user-circle'"
                  >
                  </app-icon>
                </ng-template>
              </div>

              <!-- Profile dropdown menu -->
              <div class="profile-dropdown">
                <div class="profile-dropdown-header">
                  <ng-container
                    *ngIf="user.photoUrlSmallSize; else noAvaDropdown"
                  >
                    <img
                      [src]="user.photoUrlSmallSize"
                      class="profile-dropdown-avatar"
                    />
                  </ng-container>
                  <ng-template #noAvaDropdown>
                    <app-icon
                      [class]="'profile-dropdown-avatar-icon'"
                      [color]="'#ffffff'"
                      [iconName]="['Peoples', 'user']"
                    ></app-icon>
                  </ng-template>
                  <div class="profile-dropdown-info">
                  <span class="profile-dropdown-label">{{
                      "profile_dropdown.PROFILE" | translate
                    }}</span>
                    <span class="profile-dropdown-login-row">
                    <span
                      [title]="'profile_dropdown.LOGIN' | translate"
                      class="profile-dropdown-login"
                    >
                      {{ user.login }}
                    </span>
                    <app-icon
                      (click)="copyLogin($event)"
                      [color]="'#7c86a5'"
                      [iconName]="['Edit', 'copy']"
                      [size]="12"
                      [title]="'profile_dropdown.COPY_LOGIN' | translate"
                      class="profile-dropdown-copy-icon"
                    ></app-icon>
                    <span *ngIf="copied" class="copy-tooltip">{{
                        "profile_dropdown.COPIED" | translate
                      }}</span>
                  </span>
                  </div>
                </div>
                <div class="profile-dropdown-menu">
                  <a
                    [routerLink]="['/', 'settings', 'user']"
                    class="profile-dropdown-item"
                  >
                    <app-icon
                      [color]="'#3f5bf6;'"
                      [iconName]="['Base', 'setting-two']"
                      [size]="18"
                    ></app-icon>
                    <span>{{ "profile_dropdown.SETTINGS" | translate }}</span>
                  </a>
                  <a
                    (click)="switchToClassicDesign()"
                    class="profile-dropdown-item"
                    href="javascript:void(0)"
                  >
                    <app-icon
                      [color]="'#3f5bf6;'"
                      [iconName]="['Arrows', 'rotate']"
                      [size]="18"
                    ></app-icon>
                    <span>{{
                        "profile_dropdown.SWITCH_TO_CLASSIC" | translate
                      }}</span>
                  </a>
                  <a
                    (click)="logout()"
                    class="profile-dropdown-item"
                    href="javascript:void(0)"
                  >
                    <app-icon
                      [color]="'#3f5bf6;'"
                      [iconName]="['Arrows', 'logout']"
                      [size]="18"
                    ></app-icon>
                    <span>{{ "profile_dropdown.LOGOUT" | translate }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="right-content">
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        </div>

      </main>
    </div>
  </div>
</ng-template>

<dx-popup
  [(visible)]="isRequiredPersonalDataOpen"
  [closeOnOutsideClick]="false"
  [dragEnabled]="true"
  [height]="'60%'"
  [resizeEnabled]="false"
  [showTitle]="false"
  [width]="'40%'"
>
  <form
    (submit)="onSavePrivasy()"
    *ngIf="isRequiredPersonalDataOpen"
    action="javascript:void(1);"
    class="tr-form-privasy"
  >
    <div class="warning">
      {{ "body.privacy_data_collection_form.WARNING_MESSAGE" | translate }}
    </div>

    <div>
      <div class="field-item_privasy">
        <div class="field-label">
          {{
            "body.privacy_data_collection_form.LASTNAME_FIELD_LABEL" | translate
          }}
        </div>
        <div class="field">
          <dx-text-box [(value)]="privacy.lastName">
            <dx-validator>
              <dxi-validation-rule
                [message]="
                  'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED'
                    | translate
                "
                type="required"
              >
              </dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">
          {{
            "body.privacy_data_collection_form.FIRSTNAME_FIELD_LABEL"
              | translate
          }}
        </div>
        <div class="field">
          <dx-text-box [(value)]="privacy.firstName">
            <dx-validator>
              <dxi-validation-rule
                [message]="
                  'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED'
                    | translate
                "
                type="required"
              >
              </dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">
          {{
            "body.privacy_data_collection_form.MIDDLENAME_FIELD_LABEL"
              | translate
          }}
        </div>
        <div class="field">
          <dx-text-box [(value)]="privacy.middleName">
            <dx-validator>
              <dxi-validation-rule
                [message]="
                  'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED'
                    | translate
                "
                type="required"
              >
              </dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">
          {{
            "body.privacy_data_collection_form.EMAIL_FIELD_LABEL" | translate
          }}
        </div>
        <div class="field">
          <dx-text-box [(value)]="privacy.email">
            <dx-validator>
              <dxi-validation-rule
                [message]="
                  'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED'
                    | translate
                "
                type="required"
              >
              </dxi-validation-rule>

              <dxi-validation-rule
                [message]="'employees.EDIT.WRONG_EMAIL' | translate"
                type="email"
              >
              </dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="field-item_privasy">
        <div class="field-label">
          {{
            "body.privacy_data_collection_form.PHONE_FIELD_LABEL" | translate
          }}
        </div>
        <div class="field">
          <dx-text-box [(value)]="privacy.phone" mask="+7 (000) 000-00-00">
            <dx-validator>
              <dxi-validation-rule
                [message]="
                  'administration.PROJECT_NEW.PROJECT_NAME_TRANSLIT_REQUIRED'
                    | translate
                "
                type="required"
              >
              </dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div>
        <dx-check-box [value]="false">
          <dx-validator>
            <dxi-validation-rule
              [message]="
                'privacy_data_collection_form.CONSENT_NOTICE_VALIDATION_MESSAGE'
                  | translate
              "
              type="required"
            >
            </dxi-validation-rule>
            <!-- <dxi-validation-rule type="compare"
              [message]="'Вы должы согласиться на обработку персональных данных'">
            </dxi-validation-rule> -->
          </dx-validator>
        </dx-check-box>
        {{
          "body.privacy_data_collection_form.consent_notice_requirement.TEXT"
            | translate
        }}
        <a
          download=""
          href=" https://i.tr-portal.ru/l/InStoreWorks/oferts/tr-oferta.pdf"
          target="_blank"
          >{{
            "body.privacy_data_collection_form.consent_notice_requirement.LINK"
              | translate
          }}</a
        >.
      </div>
      <!-- <dx-validation-summary id="summary-1" class="tr-form-messages errors"></dx-validation-summary> -->
      <div class="button-container">
        <dx-button
          [disabled]="loginLoading"
          [template]="'buttonTemplate'"
          [useSubmitBehavior]="true"
          class="entry-btn"
        >
          <div *dxTemplate="let buttonData of 'buttonTemplate'">
            <fa-icon
              *ngIf="loginLoading"
              [animation]="'spin'"
              [icon]="['fas', 'spinner']"
            ></fa-icon>
            {{ "body.privacy_data_collection_form.BUTTON_TEXT" | translate }}
          </div>
        </dx-button>
      </div>
    </div>
  </form>
</dx-popup>
